// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__3KkVf","img":"style_img__3wWfN"};